export const PROJECT_EVENTS_SUMMARY_CONFIG = {
    name            : 'Events summary',
    menuName        : 'Events summary',
    icon            : 'i5-events-summary',
    image           : 'events-summary',
    iconSvg         : 'isvg-view-events-summary',
    stringId        : 'events-summary',
    url             : 'events-summary',
    description     : 'Current, previous, and next week’s events and milestones.',
    // canBeInProject  : true,
    // inheritance     : true,
    isSingleton     : false
}
